// src/components/MorningBlocker.tsx
// src/components/MorningBlocker.tsx
import { useEffect, useState } from "react";
import { Box, Typography, Divider } from "@mui/material";
import { getPendingCount } from "../api/firmas";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import gorillaAdvertencia from "../imagenes/Gorillaadvertencia.png";

export default function MorningBlocker({
  isProfessor,
  logout,
}: {
  isProfessor: boolean;
  logout?: () => void;
}) {
  const [n, setN] = useState<number>(0);
  const [show, setShow] = useState(false);
  const nav = useNavigate();
  const { t } = useTranslation<"translation">();

  async function refresh() {
    try {
      const count = await getPendingCount();
      setN(count);
      setShow(count > 0); // mostrar si hay pendientes
    } catch (e) {
      // Error obteniendo count de firmas
    }
  }

  useEffect(() => {
    if (!isProfessor) return;
    void refresh();

    // refresco al firmar algo
    const onSigned = () => void refresh();
    window.addEventListener("firmas:signed", onSigned);
    return () => window.removeEventListener("firmas:signed", onSigned);
  }, [isProfessor]);

  if (!show) return null;

  return (
    <div style={overlay}>
      <div style={modal}>
        <Box
          sx={{
            display: "flex",
            gap: 4,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* Columna de texto */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center", // centra horizontalmente
              textAlign: "center", // centra el texto
            }}
          >
            <h2 style={{ marginTop: 0 }}>
              {t("morningBlocker.tienes")} {n} {t("morningBlocker.clases")}
            </h2>

            <Divider
              sx={{
                width: 100,
                height: 4,
                backgroundColor: "#1e9e85",
                mb: 3,
              }}
            />

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                fontSize: "1rem",
                maxWidth: "600px",
                mb: 4,
                lineHeight: 1.3,
              }}
            >
              {t("morningBlocker.warning")}
            </Typography>

            <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
              <button
                style={{
                  backgroundColor: "#1e9e85", // verde plano
                  color: "#fff", // texto blanco
                  border: "none",
                  borderRadius: "50px", // redondeado
                  padding: "10px 24px", // tamaño del botón
                  cursor: "pointer",
                  fontWeight: "normal",
                  marginRight: "8px", // gap entre botones
                  textTransform: "none",
                }}
                onClick={() => {
                  setShow(false);
                  nav("/app/firmas/pendientes");
                }}
              >
                {t("morningBlocker.revisar")}
              </button>
              {logout && <button onClick={logout}>Cerrar sesión</button>}
            </Box>
          </Box>

          {/* Columna de imagen */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={gorillaAdvertencia}
              alt="Gorilla"
              sx={{
                height: 260,
                maxWidth: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      </div>
    </div>
  );
}

const overlay: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};
const modal: React.CSSProperties = {
  background: "#fff",
  padding: 24,
  borderRadius: 8,
  width: 800,
  maxWidth: "90%",
};
